import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { API_BASE_URL } from "../../config";
import "./HomePage.css";

function GoogleIcon({ size = 16 }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width={size}
            height={size}
            aria-hidden="true"
        >
            <path
                fill="#EA4335"
                d="M12 10.2v3.96h5.5c-.24 1.4-1.66 4.1-5.5 4.1-3.32 0-6.02-2.74-6.02-6.12s2.7-6.12 6.02-6.12c1.88 0 3.14.8 3.86 1.48l2.64-2.54C16.78 3.32 14.6 2.4 12 2.4 6.78 2.4 2.5 6.66 2.5 11.94S6.78 21.48 12 21.48c6.94 0 9.5-4.86 9.5-7.36 0-.5-.06-.88-.14-1.26H12z"
            />
        </svg>
    );
}

const handleLogin = () => {
    window.location.href = `${API_BASE_URL}/login/google?next=%2Fdashboard`;
};

function HomePage({ user }) {
    return (
        <div className="home-page">
            <div className="home-page__grid" aria-hidden="true" />

            <header className="home-page__top">
                <div className="home-page__brand">
                    <span className="home-page__mark" aria-hidden="true">
                        <svg viewBox="0 0 16 16" width="14" height="14">
                            <rect
                                x="1"
                                y="1"
                                width="14"
                                height="14"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="1.25"
                            />
                            <rect x="4.5" y="4.5" width="7" height="7" fill="currentColor" />
                        </svg>
                    </span>
                    <span className="home-page__brand-name">PACKERAI</span>
                </div>
                <span className="home-page__build mono">v1.0 · BUILD 0481</span>
            </header>

            <main className="home-page__main">
                <div className="home-page__panel">
                    <div className="home-page__eyebrow uppercase-label">
                        Console / Sign-in
                    </div>
                    <h1 className="home-page__headline">
                        Pack tighter.<br />
                        <span className="home-page__headline-accent">Ship faster.</span>
                    </h1>
                    <p className="home-page__lede">
                        A 3D bin-packing console for freight operators. Compute the optimal
                        layout for any container in seconds.
                    </p>

                    <div className="home-page__cta">
                        {user ? (
                            <Link
                                to="/dashboard"
                                className="home-page__btn home-page__btn--primary focus-ring"
                            >
                                Continue to console
                                <ArrowRight size={16} aria-hidden="true" />
                            </Link>
                        ) : (
                            <button
                                type="button"
                                className="home-page__btn home-page__btn--primary focus-ring"
                                onClick={handleLogin}
                            >
                                <GoogleIcon size={16} />
                                Sign in with Google
                            </button>
                        )}
                        <span className="home-page__cta-note mono">
                            No payment required · OAuth via Google
                        </span>
                    </div>
                </div>
            </main>

            <footer className="home-page__foot">
                <span className="mono">ENGINEERED FOR FREIGHT</span>
                <span className="home-page__foot-rule" aria-hidden="true" />
                <span className="mono">REACT · THREE.JS</span>
            </footer>
        </div>
    );
}

export default HomePage;
